import "./CompareGridColumn.scss";

import React from "react";

import {
  Grid2,
  Typography
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

import { Column } from "../../models/app-data-model";
import RichTextBlock from "../rich-text-block/RichTextBlock";

export type CompareGridColumnProps = {
  column: Column;
};


const CompareGridColumn: React.FC<CompareGridColumnProps> = ({ column }) => {
  const columnTitle = <Typography variant="h6">{column.title}</Typography>;
  const columnValue = <Typography variant="body1">{column.value}</Typography>;

  const columnTitleWithToolTip = column.value_tooltip_reference && column.value_tooltip_reference.length > 0 && column.value_tooltip_reference[0]?.content &&
    <Tooltip title={<Typography variant="body2"><RichTextBlock content={column.value_tooltip_reference[0]?.content} /></Typography>} arrow placement="top-start" className='tool-tip'>{columnTitle}</Tooltip>;
  const compareGridColumnDisclaimer = column.disclaimer_text && <Typography variant="body2" className='column-item'>
    <RichTextBlock content={column.disclaimer_text} />
  </Typography>;

  return <Grid2 size={12} container rowSpacing={2} columnSpacing={6} className='compare-grid-column'>
            <Grid2 size={{xs:6, md:4}} className='column-item'>
              {columnTitleWithToolTip || columnTitle}
            </Grid2>
            <Grid2 size='grow' className='column-item'>
              {columnValue}
              {compareGridColumnDisclaimer}
            </Grid2>
          </Grid2>;
};

export default CompareGridColumn;
